import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search, Flag, ArrowRight } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import Navbar from '../components/layout/Navbar';
import PageHeader from '../components/layout/PageHeader';
import FindYourClub from '../components/findClub/FindYourClub';
import './MyClubsPage.css';

/**
 * B-58 slices 2–3: /find-club — "Join another club" for people already in a
 * club (My Clubs links here, and the account menu, since single-club people
 * are taken straight past My Clubs). People with no club search right on the
 * My Clubs landing. Signed in only (spec): signed out → login and back.
 */
const FindClubPage = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) navigate('/login', { replace: true, state: { from: '/find-club' } });
  }, [user, loading, navigate]);

  if (loading || !user) {
    return (
      <div className="page-loading">
        <div className="spinner" style={{ width: 40, height: 40 }} />
      </div>
    );
  }

  return (
    <div className="my-clubs-page">
      <Navbar />
      <PageHeader
        icon={Search}
        title="Find your club"
        subtitle={<>Search by name or town, then ask to join. An admin at the club approves it.</>}
      />
      <div className="my-clubs-inner">
        <div className="no-club-landing">
          <div className="no-club-card">
            <div className="no-club-card-icon"><Search size={22} /></div>
            <div className="no-club-card-body">
              <h3>Which club?</h3>
              <FindYourClub autoFocus />
            </div>
          </div>
          <div className="no-club-card">
            <div className="no-club-card-icon"><Flag size={22} /></div>
            <div className="no-club-card-body">
              <h3>Not on Marakin yet?</h3>
              <p>
                Ask someone at the club for an invite link, or set it up yourself in about
                two minutes and you're its admin.
              </p>
              <Link to="/create-club" className="btn btn-secondary">
                Start a club <ArrowRight size={15} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FindClubPage;
